import axios from 'axios';
import router from '../router/index';
import { Message } from 'element-ui';
import { Store } from 'vuex';
const eventalbum = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 20,
            total: 0,
            page: 1,
        },
    }),
    mutations: {
        setEventAlbums(state, payload) {
            state.filter.total = payload.totalCount;
            state.items = payload.items;
        },
    },
    actions: {
        async saveEventAlbumSort(context, payload) {
            var res = await axios.post('/EventAlbum/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async getEventAlbum(context) {
            var res = await axios.post('/EventAlbum/List', {
                ...context.state.filter,
                skip: 0,
                take: 1000,
            });

            context.commit('setEventAlbums', res.data.data);
        },
        async getAlbum(context, payload) {
            var res = await axios.post('/EventAlbum/Get', { id: payload });
            return res;
        },
        async addUpdateAlbum(context, payload) {
            var res = await axios.post('/EventAlbum/AddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async deleteAlbum(context, payload) {
            var res = await axios.post('/EventAlbum/Delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);

            } else {
                await context.dispatch('getEventAlbum');
            }
            return res;
        },
    },
    getters: {
        getEventAlbums: (state) => state.items,
    },
};
export default eventalbum;


// WEBPACK FOOTER //
// ./src/store/eventalbum.js